import { render, staticRenderFns } from "./service-renommer.vue?vue&type=template&id=9d72db10&scoped=true"
import script from "./service-renommer.vue?vue&type=script&lang=js"
export * from "./service-renommer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d72db10",
  null
  
)

export default component.exports